// extracted by mini-css-extract-plugin
module.exports = {"recentWrap":"index-module_recentWrap_3F_j5"};